<template>  
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link">
                        <router-link to="/loja" class="fa fa-home"></router-link>
                    </li>
                    <li class="item-link">
                        <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
                    </li>
                    <li class="item-link">
                        <span>Transferência de Saldo</span>
                    </li>
                </ul>
            </div>
            <p class="alert alert-danger" style="text-align: justify">
                <span><u>IMPORTANTE:</u></span>
                <ul style="list-style: disc !important; ">                  
                    <li><b>A transferência de saldo pode ser solicitada apenas pela REVENDA para si própria ou para sua base de clientes ativos.</b></li>                  
                    <li>Caso o <b>DOADOR</b> não possua saldo suficiente em conta para a operção, a mesma será rejeitada automaticamente e uma nova solicitação deverá ser aberta quando o saldo for suficiente.</li>                  
                    <li>Ao fornecer os dados do doador, a revenda, na qualidade de Controladora de dados de seus Clientes, declara e garante que Tratou os dados de Clientes cumprindo todos os requisitos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018) e quaisquer outras leis e regulamentações brasileiras vinculantes aplicáveis à proteção dos dados pessoais; A REVENDA é responsável por garantir que os Dados Pessoais de Terceiros submetidos a Tratamento pela ALDO sob o Contrato são legítimos, atualizados e precisos, e que o tratamento foi autorizado pelo respectivo Titular dos Dados Pessoais ou atende a uma das bases legais para Tratamento previstas na LGPD.</li>
                </ul>
            </p>         
            <div class="main-content-area">
                <div class="form-item">                    
                    <div class="row">
                        <div class="col-xs-12">
                            <h2 class="box-title">Solicitação de transferência de saldo</h2>
                        </div>
                    </div>                     
                    <div class="docs-transferencia">
                        <form @submit.prevent="frmSolicitacaoTransf" v-on:keyup.enter="SolicitarTransferencia()">
                            <div class="row">
                                <div class="col-md-0">
                                        <FormHelper :inputVar="frmSolicitacaoTransf.codSolicitante"
                                                    :form="frmSolicitacaoTransf"
                                                    label="Código do Solicitante"                                                                                                       
                                                    validationType="number"
                                                    type="hidden"></FormHelper>
                                </div>                      
                                <div class="col-md-3">
                                        <FormHelper :inputVar="frmSolicitacaoTransf.emailSolicitante"
                                                    :form="frmSolicitacaoTransf"
                                                    label="E-mail do Solicitante"                                                   
                                                    validationType="email"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">                               
                                    <h2 class="box-title">Transferir De:</h2>
                                </div>                                                                 
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <form name="frm-cadastro-venda-direta" @submit.prevent="formTipoPessoa">
                                        <div class="col-md-3">
                                            <div class="choose-radio-methods">
                                                <label class="radio-option">
                                                    <input name="radio-tipo-pessoa"
                                                        value="1"
                                                        type="radio"
                                                        checked
                                                        v-on:change="limparDadosDoador()"
                                                        v-model="formRegister.tipoDoador"/>
                                                    <span>Pessoa Jurídica</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="choose-radio-methods">       
                                                <label class="radio-option">
                                                    <input name="radio-tipo-pessoa"
                                                        value="0"
                                                        type="radio"
                                                        checked
                                                        v-on:change="limparDadosDoador()"
                                                        v-model="formRegister.tipoDoador"/>
                                                    <span>Pessoa Física</span>
                                                </label>
                                            </div>
                                        </div>                                    
                                    </form>     
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="col-md-0">
                                        <FormHelper :inputVar="frmSolicitacaoTransf.codDoador"
                                                    :form="frmSolicitacaoTransf"
                                                    label="Código do Doador"                                               
                                                    type="hidden"></FormHelper>
                                    </div>                                     
                                    <div class="col-md-3">
                                        <div v-show="formRegister.tipoDoador == 1">
                                            <FormHelper :inputVar="frmSolicitacaoTransf.CNPJDoador"
                                                        :form="frmSolicitacaoTransf"
                                                        id="CNPJDoador"
                                                        label="CNPJ Doador"
                                                        mask="##.###.###/####-##"
                                                        validationType="cnpj"                                       
                                                        :disabled="frmSolicitacaoTransf.loadingCpfCnpjDoador || disabledForm"></FormHelper>
                                        </div> 
                                        <div v-show="formRegister.tipoDoador == 0">
                                            <FormHelper :inputVar="frmSolicitacaoTransf.CPFDoador"
                                                        :form="frmSolicitacaoTransf"
                                                        id="CPFDoador"
                                                        label="CPF Doador"
                                                        :mask="['###.###.###-##']"
                                                        placeholder="000.000.000-00"
                                                        validationType="cpf"                                       
                                                        :disabled="frmSolicitacaoTransf.loadingCpfCnpjDoador || disabledForm"
                                                        ></FormHelper>
                                        </div>                                        
                                    </div>
                                    <div class="col-md-4">
                                        <FormHelper :inputVar="frmSolicitacaoTransf.nomeDoador"
                                                    :form="frmSolicitacaoTransf"
                                                    label="Nome do Doador"
                                                    placeholder="Preenchido ao consultar"
                                                    validationType="quotes"
                                                    :disabled="true"></FormHelper>
                                    </div>  
                                    <div class="col-md-5">
                                        <div class="col-md-6">
                                            <FormHelper :inputVar="frmSolicitacaoTransf.nrPedido"
                                                        :form="frmSolicitacaoTransf"
                                                        label="Pedido Doador" 
                                                        mask="#######-#"
                                                        placeholder="0000000-0"
                                                        ></FormHelper> 
                                        </div>                                        
                                        <div class=" col-xs-2  col-only-button">
                                            <button aria-label="" id="btn-search" class="btn primary-button stretch" v-on:click="ConsultarClientePedido()">
                                                <i id="btn-icon" class="fa fa-search"></i>
                                            </button>
                                        </div>
                                        <h4>
                                            <span v-if="pedidoNEncontrado" style="color: red">Pedido não encontrado!</span>                                       
                                        </h4>
                                    </div>                                    
                                    <div class="col-md-5">
                                        <div class="col-md-6">
                                            <FormHelper :inputVar="frmSolicitacaoTransf.nrNotaFiscal"
                                                        :form="frmSolicitacaoTransf"
                                                        label="Nota Fiscal Doador" 
                                                        mask="########"
                                                        placeholder="00000000"
                                                        ></FormHelper> 
                                        </div>                                        
                                        <div class=" col-xs-2  col-only-button">
                                            <button aria-label="" id="btn-search" class="btn primary-button stretch" v-on:click="ConsultarClienteNota()">
                                                <i id="btn-icon" class="fa fa-search"></i>
                                            </button>
                                        </div>
                                        <h4>
                                            <span v-if="notaNEncontrada" style="color: red">Nota Fiscal não encontrada!</span>                                       
                                        </h4>                                   
                                    </div>
                                </div>                                                       
                            </div>
                            <div class="row">                                                              
                                <div class="col-md-6">
                                    <h2 class="box-title">Transferir Para:</h2>
                                </div>                                
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <form name="frm-cadastro-venda-direta" @submit.prevent="formTipoPessoa">
                                        <div class="col-md-2">
                                            <div class="choose-radio-methods">
                                                <label class="radio-option">
                                                    <input name="radio-tipo-pessoa"
                                                        value="1"
                                                        type="radio"
                                                        checked
                                                        v-on:change="limparDadosRecebedor()"
                                                        v-model="formRegister.tipoRecebedor">
                                                    <span>Pessoa Jurídica</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="choose-radio-methods">
                                                <label class="radio-option">
                                                    <input name="radio-tipo-pessoa"
                                                        value="0"
                                                        type="radio"
                                                        checked
                                                        v-on:change="limparDadosRecebedor()"
                                                        v-model="formRegister.tipoRecebedor">
                                                    <span>Pessoa Física</span>
                                                </label>
                                            </div>
                                        </div>                                    
                                    </form>
                                </div>                                  
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="col-md-0">
                                        <FormHelper :inputVar="frmSolicitacaoTransf.codRecebedor"
                                                    :form="frmSolicitacaoTransf"
                                                    label="Código do Recebedor"
                                                    type="hidden"
                                                    validationType="number"
                                                    maxlength="10"></FormHelper>
                                    </div>
                                    <div class="col-md-3">
                                        <div v-show="formRegister.tipoRecebedor == 1">
                                            <FormHelper :inputVar="frmSolicitacaoTransf.CNPJRecebedor"
                                                        :form="frmSolicitacaoTransf"
                                                        label="CNPJ Recebedor"
                                                        mask="##.###.###/####-##"
                                                        validationType="cnpj"                                       
                                                        :disabled="frmSolicitacaoTransf.loadingCpfCnpjRecebedor || disabledForm"></FormHelper>
                                        </div> 
                                        <div v-show="formRegister.tipoRecebedor == 0">
                                            <FormHelper :inputVar="frmSolicitacaoTransf.CPFRecebedor"
                                                        :form="frmSolicitacaoTransf"
                                                        label="CPF Recebedor"
                                                        :mask="['###.###.###-##']"
                                                        validationType="cpf"                                       
                                                        :disabled="frmSolicitacaoTransf.loadingCpfCnpjRecebedor || disabledForm"
                                                        ></FormHelper>
                                        </div>                               
                                    </div>
                                    <div class="col-md-4">
                                        <FormHelper :inputVar="frmSolicitacaoTransf.nomeRecebedor"
                                                    :form="frmSolicitacaoTransf"
                                                    label="Nome do Recebedor"
                                                    validationType="quotes"
                                                    :disabled="true"></FormHelper>
                                    </div>
                                    <div class="col-md-2">
                                        <Loader style="margin-top: 20px" v-if="frmSolicitacaoTransf.loadingCnpj" />
                                    </div> 
                                </div>
                            </div>
                            <div class="row">                                                              
                                <div class="col-md-6">
                                    <h2 class="box-title">Detalhes:</h2>
                                </div>                                
                            </div>
                            <div class="row">
                                <div class="col-md-12"> 
                                    <!-- <div class="col-md-3">
                                        <FormHelper :inputVar="frmSolicitacaoTransf.tipoSaldo"
                                                    :form="frmSolicitacaoTransf"                                      
                                                    type="select"
                                                    label="Tipo de Saldo"
                                                    :options="getTipoSaldo()"                                                    
                                                    placeholder="Selecione o tipo de saldo"></FormHelper>                                     
                                    </div>                              -->
                                    <div class="col-md-2">
                                        <FormHelper :inputVar="frmSolicitacaoTransf.valorTransferencia"
                                                    :form="frmSolicitacaoTransf"
                                                    type="money"
                                                    label="Valor a Transferir" 
                                                    :min="0.01"
                                                    :max="100000000"
                                                    validationType="rangeValue"></FormHelper>
                                    </div>
                                    <div class="col-md-3"> 
                                        <FormHelperBlob :inputVar="frmSolicitacaoTransf.documentoTransf"
                                                        :form="frmSolicitacaoTransf"
                                                        label="Autorização de Transferência Assinada"                                                   
                                                        type="file"                                                    
                                                        :fileTypes="['pdf','jpg']">                                                    
                                        </FormHelperBlob>
                                    </div> 
                                    <div class="col-md-4">
                                        <FormHelper :inputVar="frmSolicitacaoTransf.descricao"
                                                    :form="frmSolicitacaoTransf"
                                                    label="Motivo"
                                                    type="textarea"
                                                    maxlength="1000"
                                                    placeholder="Motivo"></FormHelper>
                                    </div> 
                                </div>                                
                            </div>                             
                        </form>
                    </div>
                </div>
                <div v-if="frmSolicitacaoTransf.attemptSubmit && formErrors > 0" class="row">
                    <div class="col-md-12">
                        <div class="form-errors alert alert-danger" role="alert">
                            <i class="fa fa-warning"></i>
                            Seu formulário possui {{ formErrors }} erros. Por favor, corrija antes de prosseguir.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-1">
                        <button aria-label="Salvar" class="btn btn-primary" 
                        v-on:click="SolicitarTransferencia()" :disabled="(formErrors > 0 
                        && frmSolicitacaoTransf.attemptSubmit) || loadingRegister">
                            Solicitar Transferência de Saldo
                        </button>                            
                    </div>                         
                    <div v-if="loadingRegister" class="col-md-5">
                        <Loader />
                    </div>                           
                </div>            
            </div>
        </div>
    </main>
</template>
<script>
    import FormHelper from "../../components/partials/FormHelper.vue"; 
    import FormHelperBlob from "../../components/partials/FormHelperBlob.vue";
    import axios from 'axios';
    export default {
        name: "SolicitacaoTransferenciaSaldo",
        data() {
            return {
                HasNoData: true,  
                invalidCnpj: true,
                loadingRegister: false,
                disabledForm: false,
                pedidoNEncontrado: false,
                notaNEncontrada: false,
                digitado: true,
                file: null,

                formRegister: {
                    tipoDoador: 1,
                    tipoRecebedor: 1
                },

                frmSolicitacaoTransf: {
                    attemptSubmit: false,

                    //* Dados Solicitante */
                    codSolicitante: new this.formInput(false),
                    //nomeSolicitante: new this.formInput(false),
                    //CPFCNPJSolicitante: new this.formInput(false),
                    emailSolicitante: new this.formInput(),

                    //* Dados Doador */                    
                    codDoador: new this.formInput(false),
                    nomeDoador: new this.formInput(false),
                    CPFDoador: new this.formInput(),
                    CNPJDoador: new this.formInput(),                     
                    nrPedido: new this.formInput(false),
                    nrNotaFiscal: new this.formInput(false),
                    loadingCpfCnpjDoador: false,

                    //**Dados Recebedor */
                    codRecebedor: new this.formInput(false),
                    nomeRecebedor: new this.formInput(false),
                    CNPJRecebedor: new this.formInput(),
                    CPFRecebedor: new this.formInput(),
                    loadingCpfCnpjRecebedor: false,

                    //**Dados Saldo e documentação */
                    valorTransferencia: new this.formInput(),
                    documentoTransf: new this.formInput(true), //setar true
                    //tipoSaldo: new this.formInput(true),
                    descricao: new this.formInput(),                    

                    /* Pesssoa Juridica */
                    //cnpj: new this.formInput(),                    
                    cnpjInvalid: false,
                    situacaoIe: false,
                    ramoAtividades: [],
                    disabledFantasia: true,
                    loadingCnpj: false,
                    loadingValidCNPJ: false
                }
            }
        },
        components: {
            FormHelper,
            FormHelperBlob
        },
        mounted(){
            localStorage.currentStep = 0;
            const self = this;
            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning",
                    }).then(
                        () =>
                        (location.href =
                            `${self.$SiteUrl}/login?redirectTo=` + location.href)
                    );
                },
            });
            self.ValidarParametros('HABILITAR_SOLICITACAO_TRANSFERENCIA_SITE');
        },
        computed: {           
            formErrors: function () {                
                //Retorna os campos que estão com erro de validação
                let errors = Object.keys(this.frmSolicitacaoTransf).filter((key) => this.frmSolicitacaoTransf[key].validation && !this.frmSolicitacaoTransf[key].validation.status)
                
                //Retira 2 validações porque exite CPF ou CNPJ para cliente.
                return (errors.length - 2);             
            }
        },
        watch:{
            "frmSolicitacaoTransf.CNPJDoador.value": async function (val) {
                if (val.length == 18) {
                    let cnpj = val.replace(/[^\d]+/g, '');
                    let cliente = await this.ConsultarCliente(cnpj);                    
                    if (cliente != null){                                           
                        this.frmSolicitacaoTransf.nomeDoador.value = cliente.CliRazaosocial; 
                        this.frmSolicitacaoTransf.codDoador.value = cliente.CliCodigo;                      
                    }
                    else
                    {
                        this.frmSolicitacaoTransf.nomeDoador.value = '';
                        this.frmSolicitacaoTransf.codDoador.value = cliente.CliCodigo;
                        swal({
                            title: 'Cliente não encontrado!',                           
                            icon: 'warning'
                        });
                    }  
                }
            }, 
            "frmSolicitacaoTransf.CPFDoador.value": async function (val) {
                if (val.length == 14) {
                    let cnpj = val.replace(/[^\d]+/g, '');
                    let cliente = await this.ConsultarCliente(cnpj);                    
                    if (cliente != null){                                            
                        this.frmSolicitacaoTransf.nomeDoador.value = cliente.CliRazaosocial; 
                        this.frmSolicitacaoTransf.codDoador.value = cliente.CliCodigo;                      
                    }
                    else
                    {
                        this.frmSolicitacaoTransf.nomeDoador.value = '';
                        this.frmSolicitacaoTransf.codDoador.value = '';
                        swal({
                            title: 'Cliente não encontrado!',                           
                            icon: 'warning'
                        });
                    } 
                }
            }, 
            "frmSolicitacaoTransf.CNPJRecebedor.value": async function (val) {
                if (val.length == 18) {
                    let cnpj = val.replace(/[^\d]+/g, '');
                    let cliente = await this.ConsultarCliente(cnpj);                    
                    if (cliente != null){                                           
                        this.frmSolicitacaoTransf.nomeRecebedor.value = cliente.CliRazaosocial; 
                        this.frmSolicitacaoTransf.codRecebedor.value = cliente.CliCodigo;                      
                    }
                    else
                    {
                        this.frmSolicitacaoTransf.nomeRecebedor.value = '';
                        this.frmSolicitacaoTransf.codRecebedor.value = '';
                        this.frmSolicitacaoTransf.cnpjInvalid = true;
                        swal({
                            title: 'Cliente não encontrado!',                           
                            icon: 'warning'
                        });
                    }  
                }
            }, 
            "frmSolicitacaoTransf.CPFRecebedor.value": async function (val) {
                if (val.length == 14) {
                    let cnpj = val.replace(/[^\d]+/g, '');
                    let cliente = await this.ConsultarCliente(cnpj);                    
                    if (cliente != null){                                            
                        this.frmSolicitacaoTransf.nomeRecebedor.value = cliente.CliRazaosocial;
                        this.frmSolicitacaoTransf.codRecebedor.value = cliente.CliCodigo;                       
                    }
                    else
                    {
                        this.frmSolicitacaoTransf.nomeRecebedor.value = '';
                        this.frmSolicitacaoTransf.codRecebedor.value = '';
                        this.frmSolicitacaoTransf.cnpjInvalid = true;
                        swal({
                            title: 'Cliente não encontrado!',                           
                            icon: 'warning'
                        });
                    } 
                }
            }, 
            "frmSolicitacaoTransf.nrPedido.value": async function (val) {
                this.pedidoNEncontrado = false;                
            },
            "frmSolicitacaoTransf.nrNota.value": async function (val) {
                this.notaNEncontrada = false;
            }            
        },   
        methods: {            

            formInput: function (required, value) {
                // Define um padrão para estrutura de cada input do formulário
                this.required = required !== undefined ? required : true;
                this.value = value !== undefined ? value : "";

                this.validation = {
                    status: !this.required,
                    message: this.required ? "Por favor, preencha o campo acima" : ""
                };
            },
            
            // getTipoSaldo: function () {
            //     const tipoSaldo = [
            //         {label: "Dinheiro", value: 1},
            //         {label: "PIN", value: 2},
            //         {label: "RMA/TMG", value: 3},
            //         {label: "CMA", value: 4},
            //         {label: "Comissão", value: 5},
            //         {label: "Pedido", value: 6}
            //     ];
            //     return tipoSaldo;
            // },

            SolicitarTransferencia: function(){   
                this.frmSolicitacaoTransf.attemptSubmit = true;

                if(this.formErrors > 0)
                    return null;                

                if (this.frmSolicitacaoTransf.codDoador.value === this.frmSolicitacaoTransf.codRecebedor.value)
                {
                    return swal({
                                title: 'Erro ao Solicitar Transferência de Saldo!',
                                text: 'Não é possível o Doador e o Recebedor serem a mesma pessoa! ',
                                icon: 'warning'
                    })
                }
            
                var dados = new FormData(); 
                dados.append('trsDocumento', this.frmSolicitacaoTransf.documentoTransf.value);
                dados.append('CliCodigoSolicitante', JSON.parse(localStorage.getItem('usuarioLogado')).DadosCliente.CliCodigo);
                dados.append('TrsEmailSolicitante', this.frmSolicitacaoTransf.emailSolicitante.value);
                dados.append('CliCodigoDoador', this.frmSolicitacaoTransf.codDoador.value);
                dados.append('CliCodigoRecebedor', this.frmSolicitacaoTransf.codRecebedor.value);
                dados.append('TrsValor', this.frmSolicitacaoTransf.valorTransferencia.value.toString().replace('.', ','));
                //dados.append('TrsTipoSaldo', this.frmSolicitacaoTransf.tipoSaldo.value.value);
                dados.append('TrsDescricao', this.frmSolicitacaoTransf.descricao.value);                
                
                return axios({
                    method: "POST",
                    url: this.$apiUrlAPI + "TransferenciaSaldo/GerarSolicitacao",
                    headers: {"Content-Type": "multipart/form-data"},                    
                    data: dados                    
                }).then((response) => {                                          
                    if(response.status == 200){
                        if(response.data.registroGerado > 0 ) {  
                            console.log(response.data.registroGerado); 
                            swal({
                                title: "Solicitação Enviada",
                                text: "Foi gerada a solicitação número: " + response.data.registroGerado,
                                icon: "success"
                            }).then(() => location.href = `${this.$SiteUrl}/loja/minha-conta`)                                                                                                                        
                        }else{
                            swal({
                                title: 'Erro ao Gerar Solicitação!',
                                text: response.data.descricaoErro,
                                icon: 'warning'
                            })
                        }                        
                    }                   
                }).catch((error) =>{
                    swal({
                                title: 'Erro ao Gerar Solicitação!',
                                text: 'Não foi possível consultar as informações. Erro: ' + error,
                                icon: 'warning'
                    })
                });  
            },

            limparDadosDoador: function(event){
                this.frmSolicitacaoTransf.CPFDoador.value = '';
                this.frmSolicitacaoTransf.CNPJDoador.value = '';
                this.frmSolicitacaoTransf.nomeDoador.value = '';
                this.frmSolicitacaoTransf.codDoador.value = '';          
            },

            limparDadosRecebedor: function(){
                this.frmSolicitacaoTransf.CPFRecebedor.value = '';
                this.frmSolicitacaoTransf.CNPJRecebedor.value = '';
                this.frmSolicitacaoTransf.nomeRecebedor.value = '';
                this.frmSolicitacaoTransf.codRecebedor.value = '';
            },

            async validaCnpj(cnpj) {
                return axios.get(`${this.$apiUrl}ClienteVendaDireta.svc/verificacnpj/?cnpj=${cnpj}`)
                    .then((response) => {
                        if (response.data.Item1) {
                            swal({
                                title: response.data.Item2,
                                icon: 'warning'
                            })
                            this.frmRegisterpj.cnpj.value = '';
                            return false;
                        }
                        return true;
                    })
            },
            
            async ConsultarCliente (cnpj) { 
                var cliente = null;
                await axios({
                    method: "POST",
                    url: this.$apiUrl + "Cliente.svc/getload/cli",
                    headers: {"Content-Type": "application/json"},                    
                    data: {cli_ciccgc: cnpj}                    
                })
                .then((response) => {                                          
                    if(response.status == 200){
                        if(response.data.CliCodigo > 0) {  
                            console.log(response.data);
                            cliente = response.data;                                                                  
                        }                        
                    }                   
                }).catch((error) =>{
                    swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Não foi possível consultar as informações. Erro: ' + error,
                                icon: 'warning'
                    })
                });  
                return cliente              
            }, 

            ConsultarClientePedido () {                 
                const pedidodv = this.frmSolicitacaoTransf.nrPedido.value.split("-"); 
                
                if(pedidodv[1] == null){
                    return swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Pedido no formato incorreto! \n Por gentileza, seguir o formato "0000000-0" ',
                                icon: 'warning'
                    });
                }

                return axios({
                    method: "GET",
                    url: this.$apiUrlAPI + "Cliente/ConsultarClientePedido",
                    headers: {"Content-Type": "application/json"}, 
                    params: {
                        codigoPedido: pedidodv[0],
                        dvCodigoPedido: pedidodv[1]
                    }                    
                })
                .then((response) => {                                          
                    if(response.status == 200){
                        this.frmSolicitacaoTransf.nomeDoador.value = response.data.cliRazaosocial;
                        this.frmSolicitacaoTransf.codDoador.value = response.data.cliCodigo;
                        
                        if(response.data.cliCiccgc.length <= 11) {
                            this.formRegister.tipoDoador = 0;
                            this.frmSolicitacaoTransf.CPFDoador.value = response.data.cliCiccgc;
                        }
                        else{
                            this.formRegister.tipoDoador = 1;
                            this.frmSolicitacaoTransf.CNPJDoador.value = response.data.cliCiccgc;
                        }
                    }else{                        
                        this.frmSolicitacaoTransf.nomeDoador.value = '';
                        this.frmSolicitacaoTransf.CPFDoador.value = '';
                        this.frmSolicitacaoTransf.CNPJDoador.value = '';
                        this.frmSolicitacaoTransf.codDoador.value = '';
                        this.pedidoNEncontrado = true; 
                    } 
                }).catch((error) =>{
                    swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Não foi possível consultar as informações. Erro: ' + error,
                                icon: 'warning'
                    })
                });  
            },

            async ConsultarClienteNota () { 
                await axios({
                    method: "GET",
                    url: this.$apiUrlAPI + "Cliente/ConsultarClienteNF",
                    headers: {"Content-Type": "application/json"}, 
                    params: {
                        codigoNF: this.frmSolicitacaoTransf.nrNotaFiscal.value
                    }                    
                })
                .then((response) => {                                          
                    if(response.status == 200){
                        this.frmSolicitacaoTransf.nomeDoador.value = response.data.cliRazaosocial; 
                        this.frmSolicitacaoTransf.codDoador.value = response.data.cliCodigo;

                        if(response.data.cliCiccgc.length <= 11) {
                            this.formRegister.tipoDoador = 0;
                            this.frmSolicitacaoTransf.CPFDoador.value = response.data.cliCiccgc;
                        }
                        else{
                            this.formRegister.tipoDoador = 1;
                            this.frmSolicitacaoTransf.CNPJDoador.value = response.data.cliCiccgc;
                        }                        
                    }else{
                        this.frmSolicitacaoTransf.nomeDoador.value = ''; 
                        this.frmSolicitacaoTransf.CPFDoador.value = '';
                        this.frmSolicitacaoTransf.CNPJDoador.value = ''; 
                        this.frmSolicitacaoTransf.codDoador.value = '';                        
                        this.notaNEncontrada = true; 
                    } 
                }).catch((error) =>{
                    swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Não foi possível consultar as informações. Erro: ' + error,
                                icon: 'warning'
                    })
                });  
            },
            
            async ValidarParametros(parNome){                 
                await axios({
                    method: "GET",
                    url: this.$apiUrlAPI + "Parametros/Consultar",
                    headers: {"Content-Type": "application/json"},                    
                    params: {'nomeParametro': parNome}
                }).then(response => {  
                    if(response.status == 200){ 
                        if(response.data.parValor == "N")
                        {                                           
                            swal({
                                title: "Erro ao Carregar Página",
                                text: "Esta página não está habilitada para uso. Por favor, consulte o administrador do sistema!",
                                icon: "warning"
                            }).then(() => location.href = `${this.$SiteUrl}/loja/minha-conta`)                         
                        }
                    }                          
                }).catch(function (error) {
                    console.log(error);                
                });
            }
        }
    };
</script>